// Fish industry tokens. Ocean-blue palette (deep blue primary, cyan accent)
// with the Coastal layout; Hanken Grotesk UI.
import { baseTokens } from '../_base/tokens.js';

export const fishTokens = {
  ...baseTokens,
  token: {
    ...baseTokens.token,
    colorPrimary: '#005f99',
    colorInfo: '#005f99',
    colorLink: '#005f99',
    colorPrimaryHover: '#004c7a',
    colorLinkHover: '#004c7a',
    colorPrimaryActive: '#003f66',
    colorSuccess: '#2f8d3c',
    colorWarning: '#f7b733',
    colorBgLayout: '#f7fafb',
    colorTextBase: '#081a33',
    colorBorder: '#cdeaf7',
    borderRadius: 8,
    fontFamily: "'Hanken Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  components: {
    ...baseTokens.components,
    Button: { borderRadius: 999, fontWeight: 600 },
    Card: { borderRadiusLG: 16 },
    Input: { borderRadius: 999 },
    Select: { borderRadius: 999 },
  },
};
